export default __webpack_public_path__ + "static/media/ic_search.438d2a7a.png";